import { ThemeConfig } from 'antd'
import { COLORS, SHADOWS } from './tokens'

const theme: ThemeConfig = {
  token: {
    colorPrimary: COLORS.primary,
    borderRadius: 4,
    colorText: COLORS.textPrimary,
    fontFamily: 'WixMadeforDisplay',
    fontSize: 14,
    fontSizeXL: 20,
  },
  components: {
    Input: {
      controlHeight: 48,
      activeShadow: 'none',
      colorTextDisabled: COLORS.disabled,
      borderRadius: 4,
      colorTextPlaceholder: COLORS.disabled,
      colorText: COLORS.textPrimary,
      colorPrimary: COLORS.textPrimary,
      activeBg: 'transparent',
      colorErrorBorderHover: COLORS.error,
      colorError: COLORS.error,
      colorErrorActive: COLORS.error,
      colorErrorOutline: 'none',
      hoverBorderColor: COLORS.borderPrimary,
      colorBgContainer: 'transparent',
      colorBorder: COLORS.borderPrimary,
      inputFontSize: 13,
    },
    Drawer: {
      colorBgElevated: COLORS.background,
      colorIcon: COLORS.textSecondary,
      colorText: COLORS.textPrimary,
      fontWeightStrong: 700,
      fontSize: 13,
    },
    Button: {
      colorPrimary: COLORS.primary,
      controlHeight: 48,
      borderRadius: 4,
      fontWeight: 700,
      fontSize: 16,

      boxShadow: SHADOWS.boxShadow,
      boxShadowSecondary: SHADOWS.boxShadow,
      defaultShadow: SHADOWS.boxShadow,
      primaryShadow: SHADOWS.boxShadow,

      // Normalize borders
      defaultBorderColor: 'transparent',
      defaultHoverBorderColor: 'transparent',
      defaultActiveBorderColor: 'transparent',

      // Hover / active states
      colorPrimaryBgHover: COLORS.primary,
      colorPrimaryActive: COLORS.primary,

      // Disabled background
      colorBgContainerDisabled: COLORS.disabled,
    },

    Layout: {
      bodyBg: COLORS.background,
      headerBg: COLORS.background,
      footerBg: COLORS.background,
      headerHeight: 88,
      siderBg: COLORS.background,
    },
    Menu: {
      itemBg: COLORS.background,
      itemHeight: 27,
      itemSelectedBg: COLORS.primary,
      itemSelectedColor: COLORS.textSecondary,
      itemHoverColor: COLORS.disabled,
      iconSize: 16,
      itemPaddingInline: 6,
      itemMarginInline: 13,
    },
    Modal: {
      titleFontSize: 13,
      titleColor: COLORS.textPrimary,
      contentBg: 'transparent',
      headerBg: COLORS.background,
      paddingMD: 0,
      paddingContentHorizontalLG: 0,
    },
    Segmented: {
      trackBg: 'transparent',
      itemActiveBg: 'transparent',
      itemColor: COLORS.textPrimary,
      itemSelectedBg: 'transparent',
      itemSelectedColor: COLORS.primary,
      borderRadiusLG: 0,
      colorBorder: 'transparent',
      trackPadding: 0,
      fontSizeLG: 16,
    },
    Card: {
      colorBgContainer: COLORS.background,
      controlHeight: 66,
      borderRadius: 4,
      colorBorder: COLORS.borderPrimary,
      colorPrimaryBorder: COLORS.borderPrimary,
      boxShadow: SHADOWS.boxShadow,
    },
    Progress: {
      circleTextColor: COLORS.textSecondary,
      colorSuccess: COLORS.textSecondary,
    },
  },
}
export default theme
